import { makeStyles } from '@mui/styles';
const offersStyles = makeStyles(({ palette }) => ({
    headerTitle: {
        color: palette.common.black,
        fontWeight: 'bold',
    },
    leftText: {
        '& svg': {
            color: palette.primary.main,
            fontSize: 'inherit',
        },
    },
    content: {
        width: '100%',
    },
    linkIcon: {
        cursor: 'pointer',
        marginLeft: '5px',
    },
    price: {
        fontWeight: 'bold',
        marginRight: 32,
    },
    rightText: {},
    disclaimer: {
        whiteSpace: 'pre-wrap',
    },
    priceSign: {
        display: 'inline-block',
    },
}), { name: 'Common_Offers' });
export default offersStyles;
//# sourceMappingURL=offers.styles.js.map